import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VEHICLE_USED_FOR_BUSINESS = {
  YES: 'yes',
  NO: 'no',
} as const;

export const VEHICLE_USED_FOR_BUSINESS_NAME = 'vehicle_used_for_business';
export const VEHICLE_USED_FOR_BUSINESS_NAME_COMPLEMENTARY =
  'vehicle_used_for_business_complementary';
interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVehicleUsedForBusiness: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VEHICLE_USED_FOR_BUSINESS_NAME_COMPLEMENTARY
      : VEHICLE_USED_FOR_BUSINESS_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy pojazd był wykorzystywany w ramach tej działalności?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-vehicle-used-for-business"
            >
              <RadioItem
                value={VEHICLE_USED_FOR_BUSINESS.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-vehicle-used-for-business-yes"
              />
              <RadioItem
                value={VEHICLE_USED_FOR_BUSINESS.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-vehicle-used-for-business-no"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
